export const getUniqueListBy = (arr, key) => {
	return arr
		? Array.from(new Map(arr.map((item) => [item[key], item])).values())
		: []
}
